import { Button } from "@somethings-ui/web";
import {
  Dialog,
  DialogContent,
  DialogDescription,
  DialogTitle,
} from "@/components/ui/dialog.tsx";

interface TrainingEscalationModalProps {
  open: boolean;
  onClose: () => void;
}

export function TrainingEscalationModal({
  open,
  onClose,
}: TrainingEscalationModalProps) {
  return (
    <Dialog open={open} onOpenChange={(next) => !next && onClose()}>
      <DialogContent
        className="items-center gap-4 rounded-md bg-surfaces-z0 p-6 text-center sm:max-w-md"
        hideCloseButton
        onOpenAutoFocus={(event) => event.preventDefault()}
      >
        <div className="flex flex-col items-center gap-4">
          <div className="flex items-center justify-center rounded-xs bg-states-successHighlight px-2 py-1">
            <span className="text-header-6 text-brand-forest">
              Simulation — nothing actually sends
            </span>
          </div>
          <div className="flex flex-col items-center">
            <DialogTitle className="text-header-3 text-text-primary">
              Escalated to the clinical team
            </DialogTitle>
            <DialogDescription className="text-body-1 text-text-secondary">
              Continue to message this teen to finish the level.
            </DialogDescription>
          </div>
          <Button variant="primary" fullWidth={false} onClick={onClose}>
            Got it
          </Button>
        </div>
      </DialogContent>
    </Dialog>
  );
}
